import React, { useState, useCallback, useEffect } from 'react'
import _ from 'lodash'

import BillingHistory from './components/billing_history'
import PendingInvoices from './components/pending_invoices'
import MarkAsPaid from './components/mark_as_paid_modal'
import * as Constants from '../../../../helpers/constants'
import { ApiHelper } from '../../../../helpers/apihelper'
import showToastNotification from './../../../widgets/toastify'
import * as InvoicesAndReceiptsConstants from './helpers/constants'

import './../../../../static/css/profile.css'

const initialState = {
  receiptData: []
}

const InvoicesAndReceipts = ({ data, getUserInfo, client }) => {
  const [state, setState] = useState(initialState)

  const getReceipts = useCallback(() => {
    let requestBody = {
      co_user_id: data.user_id || data._id,
      cop_user_id: data.user_id,
      client_secret: Constants.CLIENT_SECRET,
    }

    let body = _.pick(requestBody, ApiHelper(client, 'RECEIPT_LIST').API_BODY)

    ApiHelper(client, 'RECEIPT_LIST').API(client, body)
      .then((response) => {
        if (response.status === Constants.CO_API.SUCCESS) {
          setState(prevState => ({
            ...prevState,
            receiptData: response.data
          }))
        } else {
          showToastNotification({
            message: response.message,
            isSuccess: false,
          })
        }
      })
      .catch((err) => {
        console.log('receipt list failed: ', err)
        showToastNotification({
          message: err.message,
          isSuccess: false,
        })
      })
  }, [data.user_id, client, data._id])

  useEffect(() => {
    getReceipts()
  }, [getReceipts])


  const getBillingAddress = () => {
    let address = data.address

    if (_.isEmpty(address))
      return null

    return (
      <div className='d-flex flex-column'>
        <h5 className='billing-tab-headers'>Billing Address</h5>
        <span>{_.startCase(address.name)}</span>
        <span>{address.line1}, {address.line2}</span>
        <span>{address.country.label} - {address.postal_code}</span>
        {
          address.taxId
            ?
            <span>
              {
                address.country.label.toLowerCase() === 'india'
                  ? <>GST: </>
                  : <>Tax: </>
              }
              <span>{address.taxId}</span>
            </span>
            : null
        }
      </div>
    )
  }

  return (
    <>
      <div className="invoice-recept-tab">
        <div className="d-flex justify-content-between">
          {getBillingAddress()}
          <div className="text-end flex-grow-1 align-self-end">
            {
              _.includes(InvoicesAndReceiptsConstants.INVOICE_AND_RECEIPT_TAB[client].SHOW_BUTTONS, 'generate_receipt') &&
                data.activated_on && data.status === 'active'
                ? (
                  <MarkAsPaid
                    data={data}
                    brand="clearout"
                    getUserInfo={getUserInfo}
                    getReceipts={getReceipts}
                    client={client}
                  />
                )
                : null
            }
          </div>
        </div>
        <PendingInvoices
          data={data}
          client={client}
        />
        <BillingHistory
          receiptData={state.receiptData}
          data={data}
          client={client}
        />
      </div>
    </>
  );
};

export default InvoicesAndReceipts
